import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    cardResume: {
        display: "flex",
        paddingBottom: 12,
        boxSizing: "border-box",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        gap: 70,
    },
    cardResumeItem: {
        display: "flex",
        flexDirection: "column",
        gap: 8,
    },
    itemLabel: {
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
    },
    cardResumeItemValueNumber: {
        fontFamily: "Source Sans 3",
        fontEeight: 400,
        fontSize: 16,
        color: theme.palette.primary.dark,
    },
    cardResumeItemValueNumberCurrent: {
        fontFamily: "Source Sans 3",
        fontEeight: 400,
        fontSize: 16,
        color: theme.palette.error.main,
    },
    cardResumeItemValue: {
        display: "flex",
        alignItems: "center",
        gap: 16,
    },
}));
